import { render, staticRenderFns } from "./IStatistic.vue?vue&type=template&id=3ad9db3a&"
import script from "./IStatistic.vue?vue&type=script&lang=ts&"
export * from "./IStatistic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports